export default __webpack_public_path__ + "static/media/1252.14024c24.png";